var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ShareLinks,{staticClass:"share-links",attrs:{"heading":_vm.heading,"urls":{ url: _setup.shareUrl, facebook: _setup.shareFacebook, twitter: _setup.shareTwitter },"button-color":'semi-transparent-white',"button-size":'small',"icon-size":20}})
}
var staticRenderFns = []

export { render, staticRenderFns }